import { createRoot } from "react-dom/client";

const Dialog = ({ message, onDone }) => (
  <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.7)" }} data-testid="app-confirm">
    <div className="w-full max-w-md p-6 space-y-5" style={{ background: "var(--ss-bg)", color: "var(--ss-cream)", border: "1px solid var(--ss-border)" }}>
      <p className="text-sm" data-testid="app-confirm-message">{message}</p>
      <div className="flex gap-3 justify-end">
        <button className="btn-outline" onClick={() => onDone(false)} data-testid="app-confirm-cancel">Cancel</button>
        <button className="btn-primary" onClick={() => onDone(true)} data-testid="app-confirm-ok">Confirm</button>
      </div>
    </div>
  </div>
);

// In-app replacement for window.confirm (native dialogs are blocked in embedded webviews)
export const appConfirm = (message) => new Promise((resolve) => {
  const host = document.createElement("div");
  document.body.appendChild(host);
  const root = createRoot(host);
  const done = (v) => { root.unmount(); host.remove(); resolve(v); };
  root.render(<Dialog message={message} onDone={done} />);
});
